module.exports = __webpack_public_path__ + "img/no_empty_image.2f284dfb.png";